var modtool = {};

modtool.modapiEnabled = false;

modtool.init = function() {

  var hostname = window.location.hostname;

  if (api.isModDomain() && document.cookie.includes('hash')) {
    modtool.setModtool();
  }

};


modtool.setModtool = function() {

  modtool.checkModapi();

  var navOptionsSpanThread = document.getElementById("navOptionsSpanThread");
  var navOptionsSpanCatalog = document.getElementById("navOptionsSpanCatalog");
  var navOptionsSpan = document.getElementById("navOptionsSpan");

  if (navOptionsSpanThread !== null) {
    modtool.addModerateThreadButton(navOptionsSpanThread);
    modtool.addDynamicButtons(navOptionsSpanThread);
    modtool.addStatusIndicator(navOptionsSpanThread);
    modtool.updateDynamicButtons();
    setInterval(modtool.updateDynamicButtons, 60000);
  } else if (navOptionsSpanCatalog !== null) {
    modtool.addDynamicButtons(navOptionsSpanCatalog);
    modtool.addStatusIndicator(navOptionsSpanCatalog);
    modtool.updateDynamicButtons();
    setInterval(modtool.updateDynamicButtons, 60000);
  } else if (navOptionsSpan !== null) {
    modtool.addDynamicButtons(navOptionsSpan);
    modtool.addStatusIndicator(navOptionsSpan);
    modtool.updateDynamicButtons();
    setInterval(modtool.updateDynamicButtons, 60000);
  }

};

modtool.addModerateThreadButton = function(navBar) {

  var url = window.location.href.split('/');
  var modPage = url[3].includes("mod.js");
  var boardUri = "";
  var threadId = "";

  if(modPage){
    var regexp = /mod\.js\?boardUri=(\w+)&threadId=(\d+)/;
    var matches = url[3].match(regexp);
    boardUri = matches[1];
    threadId = matches[2];
  } else {
    boardUri = url[3];
    threadId = url[5].replace(".html", "");
  }

  var modlinkContainer = document.createElement('a');
  var button_text = "Mod On";
  var newurl = "/mod.js?boardUri=" + boardUri + "&threadId=" + threadId;

  if (modPage) {
    button_text = "Mod Off";
    newurl = "/" + boardUri + "/res/" + threadId + ".html";
  }

  var modlink = document.createTextNode(button_text);
  modlinkContainer.setAttribute('href', newurl);
  modlinkContainer.setAttribute('class', "brackets");
  modlinkContainer.appendChild(modlink);
  navBar.prepend(modlinkContainer);

};

modtool.addDynamicButtons = function(navBar) {

  var reportlinkContainer = document.createElement('a');
  var reportlink = document.createTextNode("");
  reportlinkContainer.setAttribute('href', "/openReports.js");
  reportlinkContainer.setAttribute('class', "brackets");
  reportlinkContainer.setAttribute('id', "reportlink");
  reportlinkContainer.style.display = "none";
  reportlinkContainer.appendChild(reportlink);
  navBar.prepend(document.createTextNode(' '));
  navBar.prepend(reportlinkContainer);

  var appeallinkContainer = document.createElement('a');
  var appeallink = document.createTextNode("");
  appeallinkContainer.setAttribute('href', "/appealedBans.js");
  appeallinkContainer.setAttribute('class', "brackets");
  appeallinkContainer.setAttribute('id', "appeallink");
  appeallinkContainer.style.display = "none";
  appeallinkContainer.appendChild(appeallink);
  navBar.prepend(document.createTextNode(' '));
  navBar.prepend(appeallinkContainer);

  var messagelinkContainer = document.createElement('a');
  var messagelink = document.createTextNode("");
  messagelinkContainer.setAttribute('href', "/postbox.js");
  messagelinkContainer.setAttribute('class', "brackets");
  messagelinkContainer.setAttribute('id', "messagelink");
  messagelinkContainer.innerText = "PM";
  messagelinkContainer.style.display = "none";
  messagelinkContainer.appendChild(messagelink);
  navBar.prepend(document.createTextNode(' '));
  navBar.prepend(messagelinkContainer);

};

modtool.addStatusIndicator = function(navBar) {

  var statuslinkContainer = document.createElement('a');
  var statuslink = document.createTextNode("LOGGED OUT ;_;");
  statuslinkContainer.setAttribute('class', "brackets");
  statuslinkContainer.setAttribute('id', "statuslink");
  statuslinkContainer.style.display = "none";
  statuslinkContainer.appendChild(statuslink);
  navBar.prepend(document.createTextNode(' '));
  navBar.prepend(statuslinkContainer);
  statuslinkContainer.addEventListener('click', function() {
    api.setCookie("loginredirect", window.location.pathname, "" );
    window.location.pathname = "/login.html";
  }, false);

};

modtool.checkModapi = function() {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', '/modapi.js?json=1', true);
  xhr.responseType = 'json';
  xhr.onload = function () {
    if (xhr.readyState === xhr.DONE) {
      if (xhr.status === 200) {
        document.getElementById("messagelink").style.display = "inline";
        modtool.modapiEnabled = true;
      }
    }
  };
  xhr.send(null);
};

modtool.queryModapi = function() {

  var xhr = new XMLHttpRequest();
  xhr.open('GET', '/modapi.js?json=1', true);
  xhr.responseType = 'json';
  xhr.onload = function () {
    if (xhr.readyState === xhr.DONE) {
      if (xhr.status === 200) {
        var statusLink = document.getElementById("statuslink");
        var appealLink = document.getElementById("appeallink");
        var messageLink = document.getElementById("messagelink");

        var response = xhr.response;
        if (response.status == "ok") {
          statusLink.style.display = "none";
          var numberPersonalAppeals = response.data.openPersonalAppeals;
          var numberMessages = response.data.newMessages;

          if (numberPersonalAppeals > 0){
            appealLink.innerText = "Appeals (" + numberPersonalAppeals + ")";
            appealLink.style.display = "inline";
          } else {
            appealLink.innerText = "Appeals";
            appealLink.style.display = "none";
          }

          if (numberMessages > 0){
            var counterSpan = document.createElement("SPAN");
            counterSpan.style.color = "red";
            counterSpan.style.fontWeight = 700;
            counterSpan.innerText = "(" + numberMessages + ")";
            messageLink.innerText = "PM ";
            messageLink.append(counterSpan);
          } else {
            messageLink.innerText = "PM";
          }
          messageLink.title = "Logged in as " + api.getCookies().login;

        } else if (response.status == "error") {
          statusLink.style.display = "inline";
        }
      }
    }
  };
  xhr.send(null);

};

modtool.queryReports = function() {

  var xhr = new XMLHttpRequest();
  xhr.open('GET', '/openReports.js?json=1', true);
  xhr.responseType = 'json';
  xhr.onload = function () {
    if (xhr.readyState === xhr.DONE) {
      if (xhr.status === 200) {
        var reportLink = document.getElementById("reportlink");

        var response = xhr.response;
        if (response.status == "ok") {
          var allReports = response.data.reports;
          var numberReports = allReports.length;

          for (var i = 0; i < allReports.length; i++) {
            var currentReport = allReports[i];
            var boardUri = currentReport.boardUri;
            var threadpostId = currentReport.postId || currentReport.threadId;

            var identifier = boardUri + "-" + threadpostId;

            var ignoredReports = localStorage.ignoredReports;
            var hidingData = ignoredReports ? JSON.parse(ignoredReports) : [];

            for (var j = 0; j < hidingData.length; j++) {
              var reportData = hidingData[j];

              if(identifier == reportData) {
                numberReports = numberReports - 1;
                break;
              }
            }
          }

          if (numberReports > 0){
            var counterSpan = document.createElement("SPAN");
            counterSpan.style.color = "red";
            counterSpan.style.fontWeight = 700;
            counterSpan.innerText = "(" + numberReports + ")";
            reportLink.innerText = "Reports ";
            reportLink.append(counterSpan);
            reportLink.style.display = "inline";
          } else {
            reportLink.innerText = "Reports";
            reportLink.style.display = "none";
          }
        }
      }
    }
  };
  xhr.send(null);

};

modtool.updateDynamicButtons = function() {

  if (modtool.modapiEnabled) {
    modtool.queryModapi();
  }

  modtool.queryReports();

};

modtool.init();

